const ISO_CALENDAR_DATE = /^(\d{4})-(\d{2})-(\d{2})/;

function pad2(value: number): string {
  return value.toString().padStart(2, '0');
}

export function dateToCalendarKey(date: Date): string {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

export function calendarDateKey(value: string | null | undefined): string | null {
  if (!value) return null;

  const match = ISO_CALENDAR_DATE.exec(value);
  if (match) return `${match[1]}-${match[2]}-${match[3]}`;

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return dateToCalendarKey(parsed);
}

export function compareCalendarDateValues(
  a: string | null | undefined,
  b: string | null | undefined,
): number {
  const aKey = calendarDateKey(a);
  const bKey = calendarDateKey(b);
  if (!aKey && !bKey) return 0;
  if (!aKey) return 1;
  if (!bKey) return -1;
  return aKey.localeCompare(bKey);
}

export function isOnOrAfterCalendarDate(
  value: string | null | undefined,
  minDate: Date,
): boolean {
  const key = calendarDateKey(value);
  return key !== null && key >= dateToCalendarKey(minDate);
}

function calendarParts(value: string | null | undefined): { year: number; month: number; day: number } | null {
  const key = calendarDateKey(value);
  if (!key) return null;

  const [year, month, day] = key.split('-').map(Number);
  if (!year || !month || !day) return null;
  return { year, month, day };
}

export function formatCalendarDatePtBr(value: string | null | undefined): string {
  const parts = calendarParts(value);
  if (!parts) return '--';

  return new Date(parts.year, parts.month - 1, parts.day).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
  });
}

/** Numeric `dd/mm` of a calendar date (`"2026-06-09"` → `"09/06"`); `null` when unparseable. */
export function formatCalendarDayMonthPtBr(value: string | null | undefined): string | null {
  const parts = calendarParts(value);
  if (!parts) return null;

  return `${pad2(parts.day)}/${pad2(parts.month)}`;
}

export function shortCalendarMonthLabel(value: string | null | undefined): string {
  const parts = calendarParts(value);
  if (!parts) return '';

  return new Date(parts.year, parts.month - 1, parts.day).toLocaleDateString('pt-BR', {
    month: 'short',
  });
}
